// const rules = {
//   mail_class_rules: {
//     'First-Class Mail': [
//       { field: 'mailClass', allowed_values: ['FCM', 'First-Class Mail'] },
//       { field: 'productWeight', max: 13, unit: 'oz' }
//     ],
//     'USPS Marketing Mail': [
//       { field: 'mailClass', allowed_values: ['STD', 'Marketing Mail', 'USPS Marketing Mail'] },
//       { field: 'quantity', min: 200 }
//     ],
//     'Nonprofit USPS Marketing Mail': [
//       { field: 'mailClass', allowed_values: ['Nonprofit', 'Nonprofit USPS Marketing Mail', 'NP', 'Nonprofit Std', 'Nonprofit Marketing Mail'] },
//       { field: 'quantity', min: 200 }
//     ]
//   },

//   processing_category_rules: {
//     Cards: [
//       { field: 'productHeight', max: 4.25 },
//       { field: 'productLength', max: 6 },
//       { field: 'productThickness', max: 0.016 },
//       { field: 'productWeight', max: 1, unit: 'oz' }
//     ],
//     Letters: [
//       { field: 'productHeight', min: 3.5, max: 6.125 },
//       { field: 'productLength', min: 5, max: 11.5 },
//       { field: 'productThickness', min: 0.007, max: 0.25 },
//       { field: 'productWeight', max: 3.5, unit: 'oz' }
//     ],
//     Flats: [
//       { field: 'productHeight', min: 6.125, max: 12 },
//       { field: 'productLength', min: 11.5, max: 15 },
//       { field: 'productThickness', min: 0.009, max: 0.75 },
//       { field: 'productWeight', max: 13, unit: 'oz' }
//     ],
//     Parcels: [
//       { field: 'productHeight', max: 108 },
//       { field: 'productLength', max: 108 },
//       { field: 'productThickness', max: 18 },
//       { field: 'productWeight', max: 70, unit: 'lb' }
//     ]
//   },

//   machinability_rules: {
//     Automation: [
//       { field: 'imBarcode', value: true },
//       { field: 'isUniformThickness', value: true },
//       { field: 'isFlexible', value: true }
//     ],
//     Machinable: [
//       { field: 'isFlexible', value: true },
//       { field: 'isUniformThickness', value: true },
//       { field: 'imBarcode', value: false }
//     ],
//     Nonmachinable: [
//       { field: 'isFlexible', value: false }
//     ],
//     Presorted: [
//       { field: 'presortOnly', value: true }
//     ]
//   },

//   sortation_combinations: [
//     // Nonprofit (priority)
//     { match: ['Nonprofit USPS Marketing Mail', 'Automation', 'Letters'], sortation: 'NP AUTO LETTERS' },
//     { match: ['Nonprofit USPS Marketing Mail', 'Machinable', 'Letters'], sortation: 'NP MACH LETTERS' },
//     { match: ['Nonprofit USPS Marketing Mail', 'Nonmachinable', 'Letters'], sortation: 'NP NONMACH LETTERS' },
//     { match: ['Nonprofit USPS Marketing Mail', 'Automation', 'Flats'], sortation: 'NP AUTO FLATS' },
//     { match: ['Nonprofit USPS Marketing Mail', 'Machinable', 'Flats'], sortation: 'NP MACH FLATS' },
//     { match: ['Nonprofit USPS Marketing Mail', 'Presorted', 'Flats'], sortation: 'NP PRESORTED FLATS' },

//     // Regular Marketing Mail
//     { match: ['USPS Marketing Mail', 'Automation', 'Letters'], sortation: 'STD AUTO LETTERS' },
//     { match: ['USPS Marketing Mail', 'Machinable', 'Letters'], sortation: 'STD MACH LETTERS' },
//     { match: ['USPS Marketing Mail', 'Nonmachinable', 'Letters'], sortation: 'STD NONMACH LETTERS' },
//     { match: ['USPS Marketing Mail', 'Automation', 'Flats'], sortation: 'STD AUTO FLATS' },
//     { match: ['USPS Marketing Mail', 'Machinable', 'Flats'], sortation: 'STD MACH FLATS' },
//     { match: ['USPS Marketing Mail', 'Presorted', 'Flats'], sortation: 'STD PRESORTED FLATS' },

//     // First-Class Mail
//     { match: ['First-Class Mail', 'Automation', 'Cards'], sortation: 'FCM AUTO CARDS' },
//     { match: ['First-Class Mail', 'Automation', 'Letters'], sortation: 'FCM AUTO LETTERS' },
//     { match: ['First-Class Mail', 'Automation', 'Flats'], sortation: 'FCM AUTO FLATS' },
//     { match: ['First-Class Mail', 'Machinable', 'Cards'], sortation: 'FCM MACH CARDS' },
//     { match: ['First-Class Mail', 'Machinable', 'Letters'], sortation: 'FCM MACH LETTERS' },
//     { match: ['First-Class Mail', 'Machinable', 'Flats'], sortation: 'FCM MACH FLATS' },
//     { match: ['First-Class Mail', 'Presorted', 'Flats'], sortation: 'FCM PRESORTED FLATS' },
//     { match: ['First-Class Mail', 'Nonmachinable', 'Letters'], sortation: 'FCM NONMACH LETTERS' },
//     { match: ['First-Class Mail', 'Nonmachinable', 'Cards'], sortation: 'FCM NONMACH CARDS' },

//     { match: ['Parcels'], sortation: 'PARCEL - NOT PROCESSIBLE BY OUR SERVICE' },
//     { match: ['Nonmailable'], sortation: 'NONMAILABLE - DOES NOT MEET USPS STANDARDS' }
//   ]
// };

// const getUSPSSortation = (input) => {
//   if (!input) {
//     return { sortation: 'Nonmailable', error: 'No input provided' };
//   }

//   const {
//     productHeight = 0,
//     productLength = 0,
//     productThickness = 0,
//     productWeight = 0, // ounces
//     imBarcode,
//     isUniformThickness,
//     isFlexible,
//     presortOnly,
//     mailClass = '',
//     quantity = 0,
//     isNonprofit = false
//   } = input;

//   const normalizedInput = mailClass.trim().toLowerCase();

//   // Nonprofit detection (more robust)
//   const isNP = isNonprofit ||
//     normalizedInput.includes('nonprofit') ||
//     normalizedInput.includes('np');

//   // Set selectedMailClass accurately
//   let selectedMailClass;
//   if (isNP) {
//     selectedMailClass = 'Nonprofit USPS Marketing Mail';
//   } else if (
//     normalizedInput.includes('std') ||
//     normalizedInput.includes('marketing mail') ||
//     normalizedInput.includes('usps marketing mail')
//   ) {
//     selectedMailClass = 'USPS Marketing Mail';
//   } else if (
//     normalizedInput.includes('fcm') ||
//     normalizedInput.includes('first-class mail')
//   ) {
//     selectedMailClass = 'First-Class Mail';
//   } else {
//     selectedMailClass = mailClass; // fallback
//   }

//   const aspectRatio =
//     productLength && productHeight && productHeight > 0
//       ? (productLength / productHeight).toFixed(2)
//       : 'N/A';

//   // 1. Mail class validation
//   let mailClassValid = false;
//   for (const [className, classRules] of Object.entries(rules.mail_class_rules)) {
//     let valid = true;
//     for (const rule of classRules) {
//       if (rule.field === 'mailClass') {
//         const allowed = rule.allowed_values.map(v => v.toLowerCase());
//         if (!allowed.some(a => normalizedInput.includes(a))) {
//           valid = false;
//           break;
//         }
//       }
//       if (rule.field === 'productWeight' && productWeight > rule.max) {
//         valid = false;
//         break;
//       }
//       if (rule.field === 'quantity' && quantity < rule.min) {
//         valid = false;
//         break;
//       }
//     }
//     if (valid && (isNP ? className === 'Nonprofit USPS Marketing Mail' : className === selectedMailClass)) {
//       mailClassValid = true;
//       break;
//     }
//   }

//   if (!mailClassValid) {
//     return {
//       selectedCategory: null,
//       machinability: null,
//       aspectRatio,
//       sortation: 'Nonmailable',
//       error: 'Invalid mail class, weight, or quantity'
//     };
//   }

//   // 2. Processing category (unchanged)
//   let selectedCategory = null;
//   for (const [category, catRules] of Object.entries(rules.processing_category_rules)) {
//     let valid = true;
//     for (const rule of catRules) {
//       const value = { productHeight, productLength, productThickness, productWeight }[rule.field];
//       if (rule.min !== undefined && value < rule.min) {
//         valid = false;
//         break;
//       }
//       if (rule.max !== undefined) {
//         if (rule.unit === 'lb' && productWeight / 16 > rule.max) valid = false;
//         if (!rule.unit && value > rule.max) valid = false;
//       }
//     }
//     if (valid) {
//       selectedCategory = category;
//       break;
//     }
//   }

//   if (!selectedCategory) {
//     return {
//       selectedCategory: null,
//       machinability: null,
//       aspectRatio,
//       sortation: 'Nonmailable',
//       error: 'Invalid dimensions or weight'
//     };
//   }

//   // 3. Machinability (unchanged)
//   let machinability = 'Nonmachinable';
//   if (isFlexible === false) {
//     machinability = 'Nonmachinable';
//   } else if (presortOnly === true) {
//     machinability = 'Presorted';
//   } else if (isFlexible === true && isUniformThickness === true) {
//     if (imBarcode === true) {
//       machinability = 'Automation';
//     } else {
//       machinability = 'Machinable';
//     }
//   }

//   if (selectedCategory === 'Letters' && aspectRatio !== 'N/A') {
//     const ratio = parseFloat(aspectRatio);
//     if (ratio < 1.3 || ratio > 2.5) {
//       machinability = 'Nonmachinable';
//     }
//   }

//   // 4. Sortation match
//   let sortationResult = null;
//   for (const combo of rules.sortation_combinations) {
//     const matches = combo.match.every(m =>
//       [selectedMailClass, machinability, selectedCategory].includes(m)
//     );
//     if (matches) {
//       sortationResult = combo;
//       break;
//     }
//   }

//   // Fallback - only if no direct match
//   let sortation = sortationResult?.sortation || 'Nonmailable';

//   if (!sortationResult && selectedMailClass.includes('Marketing Mail')) {
//     const prefix = isNP ? 'NP' : 'STD';

//     if (selectedCategory === 'Letters') {
//       if (machinability === 'Automation')      sortation = `${prefix} AUTO LETTERS`;
//       else if (machinability === 'Machinable') sortation = `${prefix} MACH LETTERS`;
//       else if (machinability === 'Nonmachinable') sortation = `${prefix} NONMACH LETTERS`;
//     } else if (selectedCategory === 'Flats') {
//       if (machinability === 'Automation')      sortation = `${prefix} AUTO FLATS`;
//       else if (machinability === 'Machinable' || machinability === 'Presorted') {
//         sortation = `${prefix} PRESORTED FLATS`;
//       }
//     }
//   }

//   return {
//     selectedMailClass,
//     selectedCategory,
//     machinability,
//     aspectRatio,
//     sortation,
//     isNonprofit: isNP,
//     error: sortation === 'Nonmailable' ? 'No matching sortation found' : null
//   };
// };

// export default getUSPSSortation;

const rules = {
  mail_class_rules: {
    'First-Class Mail': [
      { field: 'mailClass', allowed_values: ['FCM', 'First-Class Mail'] },
      { field: 'productWeight', max: 13, unit: 'oz' }
    ],
    'USPS Marketing Mail': [
      { field: 'mailClass', allowed_values: ['STD', 'Marketing Mail', 'USPS Marketing Mail'] },
      { field: 'quantity', min: 200 }
    ],
    'Nonprofit USPS Marketing Mail': [
      { field: 'mailClass', allowed_values: ['Nonprofit', 'Nonprofit USPS Marketing Mail', 'NP', 'Nonprofit Std', 'Nonprofit Marketing Mail'] },
      { field: 'quantity', min: 200 }
    ]
  },

  processing_category_rules: {
    Cards: [
      { field: 'productHeight', max: 4.25 },
      { field: 'productLength', max: 6 },
      { field: 'productThickness', max: 0.016 },
      { field: 'productWeight', max: 1, unit: 'oz' }
    ],
    Letters: [
      { field: 'productHeight', min: 3.5, max: 6.125 },
      { field: 'productLength', min: 5, max: 11.5 },
      { field: 'productThickness', min: 0.007, max: 0.25 },
      { field: 'productWeight', max: 3.5, unit: 'oz' }
    ],
    Flats: [
      { field: 'productHeight', min: 6.125, max: 12 },
      { field: 'productLength', min: 11.5, max: 15 },
      { field: 'productThickness', min: 0.009, max: 0.75 },
      { field: 'productWeight', max: 13, unit: 'oz' }
    ],
    Parcels: [
      { field: 'productHeight', max: 108 },
      { field: 'productLength', max: 108 },
      { field: 'productThickness', max: 18 },
      { field: 'productWeight', max: 70, unit: 'lb' }
    ]
  },

  machinability_rules: {
    Automation: [
      { field: 'imBarcode', value: true },
      { field: 'isUniformThickness', value: true },
      { field: 'isFlexible', value: true }
    ],
    Machinable: [
      { field: 'isFlexible', value: true },
      { field: 'isUniformThickness', value: true },
      { field: 'imBarcode', value: false }
    ],
    Nonmachinable: [
      { field: 'isFlexible', value: false }
    ],
    Presorted: [
      { field: 'presortOnly', value: true }
    ]
  },

  sortation_combinations: [
    // Nonprofit (priority)
    { match: ['Nonprofit USPS Marketing Mail', 'Automation', 'Letters'], sortation: 'NP AUTO LETTERS' },
    { match: ['Nonprofit USPS Marketing Mail', 'Machinable', 'Letters'], sortation: 'NP MACH LETTERS' },
    { match: ['Nonprofit USPS Marketing Mail', 'Nonmachinable', 'Letters'], sortation: 'NP NONMACH LETTERS' },
    { match: ['Nonprofit USPS Marketing Mail', 'Automation', 'Flats'], sortation: 'NP AUTO FLATS' },
    { match: ['Nonprofit USPS Marketing Mail', 'Machinable', 'Flats'], sortation: 'NP MACH FLATS' },
    { match: ['Nonprofit USPS Marketing Mail', 'Presorted', 'Flats'], sortation: 'NP PRESORTED FLATS' },

    // Regular Marketing Mail
    { match: ['USPS Marketing Mail', 'Automation', 'Letters'], sortation: 'STD AUTO LETTERS' },
    { match: ['USPS Marketing Mail', 'Machinable', 'Letters'], sortation: 'STD MACH LETTERS' },
    { match: ['USPS Marketing Mail', 'Nonmachinable', 'Letters'], sortation: 'STD NONMACH LETTERS' },
    { match: ['USPS Marketing Mail', 'Automation', 'Flats'], sortation: 'STD AUTO FLATS' },
    { match: ['USPS Marketing Mail', 'Machinable', 'Flats'], sortation: 'STD MACH FLATS' },
    { match: ['USPS Marketing Mail', 'Presorted', 'Flats'], sortation: 'STD PRESORTED FLATS' },

    // First-Class Mail
    { match: ['First-Class Mail', 'Automation', 'Cards'], sortation: 'FCM AUTO CARDS' },
    { match: ['First-Class Mail', 'Automation', 'Letters'], sortation: 'FCM AUTO LETTERS' },
    { match: ['First-Class Mail', 'Automation', 'Flats'], sortation: 'FCM AUTO FLATS' },
    { match: ['First-Class Mail', 'Machinable', 'Cards'], sortation: 'FCM MACH CARDS' },
    { match: ['First-Class Mail', 'Machinable', 'Letters'], sortation: 'FCM MACH LETTERS' },
    { match: ['First-Class Mail', 'Machinable', 'Flats'], sortation: 'FCM MACH FLATS' },
    { match: ['First-Class Mail', 'Presorted', 'Flats'], sortation: 'FCM PRESORTED FLATS' },
    { match: ['First-Class Mail', 'Nonmachinable', 'Letters'], sortation: 'FCM NONMACH LETTERS' },
    { match: ['First-Class Mail', 'Nonmachinable', 'Cards'], sortation: 'FCM NONMACH CARDS' },

    { match: ['Parcels'], sortation: 'PARCEL - NOT PROCESSIBLE BY OUR SERVICE' },
    { match: ['Nonmailable'], sortation: 'NONMAILABLE - DOES NOT MEET USPS STANDARDS' }
  ]
};

const getUSPSSortation = (input) => {
  if (!input) {
    return {
      sortation: 'Nonmailable',
      error: 'No input provided',
      reason: 'No input object provided'
    };
  }

  const {
    productHeight = 0,
    productLength = 0,
    productThickness = 0,
    productWeight = 0, // ounces
    imBarcode,
    isUniformThickness,
    isFlexible,
    presortOnly,
    mailClass = '',
    quantity = 0,
    isNonprofit = false
  } = input;

  let reasonParts = []; // Collect reasons step-by-step

  const normalizedInput = mailClass.trim().toLowerCase();

  // Nonprofit detection
  const isNP = isNonprofit ||
    normalizedInput.includes('nonprofit') ||
    normalizedInput.includes('np');

  // Determine selectedMailClass
  let selectedMailClass;
  if (isNP) {
    selectedMailClass = 'Nonprofit USPS Marketing Mail';
  } else if (
    normalizedInput.includes('std') ||
    normalizedInput.includes('marketing mail') ||
    normalizedInput.includes('usps marketing mail')
  ) {
    selectedMailClass = 'USPS Marketing Mail';
  } else if (
    normalizedInput.includes('fcm') ||
    normalizedInput.includes('first-class mail')
  ) {
    selectedMailClass = 'First-Class Mail';
  } else {
    selectedMailClass = mailClass;
  }

  const aspectRatio =
    productLength && productHeight && productHeight > 0
      ? (productLength / productHeight).toFixed(2)
      : 'N/A';

  // 1. Mail class validation
  let mailClassValid = false;
  for (const [className, classRules] of Object.entries(rules.mail_class_rules)) {
    let valid = true;
    for (const rule of classRules) {
      if (rule.field === 'mailClass') {
        const allowed = rule.allowed_values.map(v => v.toLowerCase());
        if (!allowed.some(a => normalizedInput.includes(a))) {
          valid = false;
          break;
        }
      }
      if (rule.field === 'productWeight' && productWeight > rule.max) {
        valid = false;
        break;
      }
      if (rule.field === 'quantity' && quantity < rule.min) {
        valid = false;
        break;
      }
    }
    if (valid && (isNP ? className === 'Nonprofit USPS Marketing Mail' : className === selectedMailClass)) {
      mailClassValid = true;
      break;
    }
  }

  if (!mailClassValid) {
    reasonParts.push('Mail class, weight, or quantity invalid (e.g., Marketing/Nonprofit requires ≥200 pieces, or unrecognized mailClass)');
    return {
      selectedCategory: null,
      machinability: null,
      aspectRatio,
      sortation: 'Nonmailable',
      reason: reasonParts.join(' | '),
      error: 'Invalid mail class, weight, or quantity'
    };
  }

  // 2. Processing category
  let selectedCategory = null;
  for (const [category, catRules] of Object.entries(rules.processing_category_rules)) {
    let valid = true;
    for (const rule of catRules) {
      const value = { productHeight, productLength, productThickness, productWeight }[rule.field];
      if (rule.min !== undefined && value < rule.min) {
        valid = false;
        break;
      }
      if (rule.max !== undefined) {
        if (rule.unit === 'lb' && productWeight / 16 > rule.max) valid = false;
        if (!rule.unit && value > rule.max) valid = false;
      }
    }
    if (valid) {
      selectedCategory = category;
      break;
    }
  }

  if (!selectedCategory) {
    reasonParts.push('Dimensions/weight do not fit any USPS category (Cards/Letters/Flats/Parcels)');
    return {
      selectedCategory: null,
      machinability: null,
      aspectRatio,
      sortation: 'Nonmailable',
      reason: reasonParts.join(' | '),
      error: 'Invalid dimensions or weight'
    };
  }

  // 3. Machinability + primary reason
  let machinability = 'Nonmachinable';
  if (isFlexible === false) {
    machinability = 'Nonmachinable';
    reasonParts.push('Nonmachinable: isFlexible = false');
  } else if (presortOnly === true) {
    machinability = 'Presorted';
    reasonParts.push('Presorted: presortOnly flag is true');
  } else if (isFlexible === true && isUniformThickness === true) {
    if (imBarcode === true) {
      machinability = 'Automation';
      reasonParts.push('Automation: Flexible, uniform thickness, and has IM barcode');
    } else {
      machinability = 'Machinable';
      reasonParts.push('Machinable: Flexible + uniform thickness (no IM barcode or IM barcode undefined)');
    }
  } else {
    reasonParts.push('Nonmachinable: Default (missing flexible/uniform flags or criteria not fully met)');
  }

  // Aspect ratio override (takes precedence if triggered)
  if (selectedCategory === 'Letters' && aspectRatio !== 'N/A') {
    const ratio = parseFloat(aspectRatio);
    if (ratio < 1.3 || ratio > 2.5) {
      machinability = 'Nonmachinable';
      reasonParts.push(`Nonmachinable: Aspect ratio ${aspectRatio} outside USPS 1.3–2.5 range for letters`);
    }
  }

  // 4. Sortation match
  let sortationResult = null;
  for (const combo of rules.sortation_combinations) {
    const matches = combo.match.every(m =>
      [selectedMailClass, machinability, selectedCategory].includes(m)
    );
    if (matches) {
      sortationResult = combo;
      break;
    }
  }

  let sortation = sortationResult?.sortation || 'Nonmailable';

  if (sortationResult) {
  //  reasonParts.push(`Exact match found: ${machinability} ${selectedCategory} for ${selectedMailClass}`);
  } else if (selectedMailClass.includes('Marketing Mail')) {
    const prefix = isNP ? 'NP' : 'STD';

    if (selectedCategory === 'Letters') {
      if (machinability === 'Automation')      sortation = `${prefix} AUTO LETTERS`;
      else if (machinability === 'Machinable') sortation = `${prefix} MACH LETTERS`;
      else if (machinability === 'Nonmachinable') sortation = `${prefix} NONMACH LETTERS`;
    } else if (selectedCategory === 'Flats') {
      if (machinability === 'Automation')      sortation = `${prefix} AUTO FLATS`;
      else if (machinability === 'Machinable' || machinability === 'Presorted') {
        sortation = `${prefix} PRESORTED FLATS`;
      }
    }
    if (sortation !== 'Nonmailable') {
      reasonParts.push(`Fallback applied: No exact combination matched → used ${prefix} logic for ${machinability} ${selectedCategory}`);
    }
  }

  // Final reason string
  const reason = reasonParts.length > 0 ? reasonParts.join(' | ') : 'No specific reason determined';

  return {
    selectedMailClass,
    selectedCategory,
    machinability,
    aspectRatio,
    sortation,
    isNonprofit: isNP,
    reason,
    error: sortation === 'Nonmailable' ? 'No matching sortation found - check preparation requirements' : null
  };
};

export default getUSPSSortation;